<template>
  <div class="ReimbursementDetail">
    <el-scrollbar class="formBox" v-scrollbar-height v-loading="loading">
      <div class="projectInfo">
        <el-page-header
          @back="$emit('toggle', { name: 'ReimbursementTab' })"
          content="报销申请"
          class="pageHead"
        />
        <div class="projectInfoItem">
          <div class="moduleTitle">项目信息</div>
          <div class="describeListItem">
            <div class="describeListItem">
              <div class="describeListItemL">审批状态：</div>
              <div class="describeListItemR">
                <span
                  class="status"
                  :class="{
                    info: details.Status === 0,
                    warning: details.Status === 1,
                    success: details.Status === 2,
                    danger: details.Status === 4
                  }"
                  >{{
                    details.Status === 0
                      ? '草稿'
                      : details.Status === 1
                      ? '待审批'
                      : details.Status === 2
                      ? '已通过'
                      : details.Status === 4
                      ? '已驳回'
                      : ''
                  }}</span
                >
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">提交时间：</div>
              <div class="describeListItemR">
                {{ $common.timesToTime(details.ApplyDateTime, true) }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">一级科目：</div>
              <div class="describeListItemR">
                {{ details.FinancialEntry | filterSubject }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">二级科目：</div>
              <div class="describeListItemR">
                {{ details.FinancialSubEntry | filterSubject }}
              </div>
            </div>
          </div>
          <div class="describeListItem">
            <div class="describeListItem">
              <div class="describeListItemL">申请人：</div>
              <div class="describeListItemR">
                {{ details.ApplyUserName }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">付款费用归属部门：</div>
              <div class="describeListItemR">
                {{ details.CostDeptName }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">收款人：</div>
              <div class="describeListItemR">
                {{ details.Payee }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">开户行：</div>
              <div class="describeListItemR">
                {{ details.PayeeBankName }}
              </div>
            </div>
          </div>
          <div class="describeListItem">
            <div class="describeListItem">
              <div class="describeListItemL">收款账号：</div>
              <div class="describeListItemR">
                {{ details.PayeeBankAccount }}
              </div>
            </div>
            <template v-if="isFinance || userInfo.UserName == 'Admin'">
              <div class="describeListItem">
                <div class="describeListItemL">是否进行审批：</div>
                <div class="describeListItemR">
                  {{
                    details.IsNeedToAudit === true
                      ? '是'
                      : details.IsNeedToAudit === false
                      ? '否'
                      : ''
                  }}
                </div>
              </div>
              <div class="describeListItem">
                <div class="describeListItemL">是否支出：</div>
                <div class="describeListItemR">
                  {{
                    details.IsExpenditure === true
                      ? '是'
                      : details.IsExpenditure === false
                      ? '否'
                      : ''
                  }}
                </div>
              </div>
            </template>
            <div class="describeListItem">
              <div class="describeListItemL">报销备注：</div>
              <div class="describeListItemR">
                {{ details.Remarks }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="costInfo">
        <div
          class="costInfoItem"
          :class="{ borderTop: i > 0 }"
          v-for="(item, i) in details.Fees"
          :key="i"
        >
          <div class="moduleTitle">
            费用信息 <span class="serialNum">{{ i + 1 }}</span>
          </div>
          <div class="describeListItem">
            <div class="describeListItem">
              <div class="describeListItemL">费用类型：</div>
              <div class="describeListItemR">
                {{ item.FeeCategory | filterSubject }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">费用事由：</div>
              <div class="describeListItemR">
                {{ item.FeeMemo }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">费用金额：</div>
              <div class="describeListItemR">
                {{ $common.moneyFormat(item.FeeAmount) }}
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">发生时间：</div>
              <div class="describeListItemR">
                {{ $common.timesToTime(item.OccurDate) }}
              </div>
            </div>
          </div>
          <div class="describeListItem">
            <div class="describeListItem">
              <div class="describeListItemL">发票：</div>
              <div class="describeListItemR">
                <div
                  class="fileBox"
                  v-if="
                    item.InvoiceAttachmentIds &&
                    item.InvoiceAttachmentIds != '[]'
                  "
                >
                  <div v-if="JSON.parse(item.InvoiceAttachmentIds).length > 1">
                    <el-link
                      type="primary"
                      @click="
                        lookFeesList(JSON.parse(item.InvoiceAttachmentIds))
                      "
                      >查看</el-link
                    >
                  </div>
                  <div v-else>
                    <el-link
                      type="primary"
                      @click="
                        previewEvent(JSON.parse(item.InvoiceAttachmentIds)[0])
                      "
                      >预览</el-link
                    >
                    <el-link
                      type="primary"
                      arget="_blank"
                      :href="`${BASE_API}/Common.FileStore/GetFile/Performance?logicID=${
                        JSON.parse(item.InvoiceAttachmentIds)[0]
                      }`"
                      >下载</el-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="describeListItem">
              <div class="describeListItemL">备注：</div>
              <div class="describeListItemR">
                {{ item.Remarks }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="operateProcess">
        <div class="moduleTitle">操作流程</div>
        <div class="records">
          <el-table
            :stripe="true"
            v-loading="tableLoad"
            element-loading-text="拼命加载中..."
            fit
            highlight-current-row
            :data="details.WorkflowActionList"
            border
          >
            <el-table-column
              prop="WorkflowNodeName"
              label="节点名称"
              width="240"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="OperatorName"
              label="操作人"
              width="140"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="ActionName"
              label="操作名称"
              width="140"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="ActionRemark"
              label="操作备注"
              min-width="240"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column label="操作时间" width="240" align="center">
              <template slot-scope="{ row }">
                {{ $common.timesToTime(row.OperateTime, true) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="totalBox">
        <div class="left">
          <p class="total">
            报销总金额 <i>¥</i
            ><span>{{ $common.moneyFormat(details.TotalAmount) }}</span>
          </p>
          <p class="prompt">最终费用以财务核实为准</p>
        </div>
      </div>
    </el-scrollbar>
    <!-- 图片预览 -->
    <el-dialog title="图片预览" :visible.sync="dialogImgVisible" center>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: flex-start;
          max-height: 58vh;
          overflow: auto;
          padding: 12px 0 24px 0;
        "
      >
        <img width="90%" :src="previewImgUrl" alt="" />
      </div>
    </el-dialog>
    <!-- 多张发票展示 -->
    <el-dialog
      title="发票列表"
      :visible.sync="dialogFeesValue"
      center
      width="600px"
    >
      <div style="max-height: 58vh; overflow: auto; padding: 12px 0 24px 0">
        <div
          v-for="(item, index) in InvoiceAttachmentIdsList"
          :key="index"
          style="
            display: flex;
            align-items: center;
            background-color: #fafafa;
            border-radius: 5px;
            padding: 8px 10px;
            margin: 8px 30px;
          "
        >
          <img
            :src="item | filterImg"
            alt=""
            style="width: 32px; height: 32px"
          />
          <div style="flex: 1; font-size: 14px; margin-left: 8px">
            {{ item.split(':')[1] }}
          </div>
          <div>
            <el-link
              type="primary"
              @click="previewEvent(item)"
              style="margin-right: 20px"
              >预览</el-link
            >
            <el-link
              type="primary"
              arget="_blank"
              :href="`${BASE_API}/Common.FileStore/GetFile/Performance?logicID=${item}`"
              >下载</el-link
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { basic } from '../../http/api'
var that
export default {
  name: 'ReimbursementDetail',
  props: ['ID', 'isFinance'],
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      loading: false,
      tableLoad: false,
      dialogImgVisible: false,
      details: {},
      previewImgUrl: '',
      BASE_API: window.BASE_API,
      dialogFeesValue: false, // 发票弹框
      InvoiceAttachmentIdsList: [] // 发票列表
    }
  },
  filters: {
    filterSubject (val) {
      const temp = that.$ReimburseSubject.find(item => item.Name == val)
      return (temp && temp.Title) || ''
    },
    /**
     * 过滤获取发票类型图片
     * @param {*} val 文件路径 例如：d920b586672d4a5192765cd1099fb8b4:avatar.jpg:558132
     * @returns {*} 返回匹配的文件图片路径
     */
    filterImg (val) {
      const fileNameParts = val.split(':')
      const fileName = fileNameParts[1]
      let url = ''
      switch (true) {
        case /\.(?:png|jpg|jpeg)$/i.test(fileName):
          url = '/static/picture/pciture-file-icon.png'
          break
        case /\.(?:doc|docx)$/i.test(fileName):
          url = '/static/picture/word-file-icon.png'
          break
        case /\.(?:xlsx|xls)$/i.test(fileName):
          url = '/static/picture/excel-file-icon.png'
          break
        case /\.(?:pdf)$/i.test(fileName):
          url = '/static/picture/pdf-file-icon.png'
          break
        case /\.(?:ppt|pps|pptx)$/i.test(fileName):
          url = '/static/picture/ppt-file-icon.png'
          break
        case /\.(?:zip|rar)$/i.test(fileName):
          url = '/static/picture/zip-file-icon.png'
          break
        default:
          break
      }
      return url
    }
  },
  created () {
    that = this
    if (this.ID) this.getList()
  },
  methods: {
    // 发票查看
    lookFeesList (InvoiceAttachmentIds) {
      this.dialogFeesValue = true
      this.InvoiceAttachmentIdsList = InvoiceAttachmentIds
    },
    getList () {
      this.loading = true
      basic('ReimbursementWorkflow', 'Get', { key: this.ID }).then(res => {
        let clone = JSON.parse(JSON.stringify(res))
        clone.WorkflowActionList.map(item => {
          const {
            WorkflowNodeName,
            OperatorName,
            ActionName,
            ActionRemark,
            OperateTime
          } = item
          return {
            WorkflowNodeName,
            OperatorName,
            ActionName,
            ActionRemark,
            OperateTime
          }
        })
        if (clone.CurrentNode) {
          clone.WorkflowActionList.push({
            WorkflowNodeName: clone.CurrentNode['FullName'],
            OperatorName: clone.CurrentOperatorNames
              ? clone.CurrentOperatorNames
              : clone.CurrentNode['Name'],
            ActionName: clone.CurrentNode['IsStartPoint'] ? '待处理' : '待审批',
            ActionRemark: '',
            OperateTime: ''
          })
        }
        this.details = clone
        this.loading = false
      })
    },
    // 预览格式
    previewEvent (url) {
      // 预览图片
      if (/\.(?:jpg|jpeg|png)+(:\d*)*$/i.test(url)) {
        this.dialogImgVisible = true
        this.previewImgUrl = `${this.BASE_API}/Common.FileStore/GetFile/Performance?logicID=${url}`
        // 预览docx文件
      } else if (/\.(?:pdf)+(:\d*)*$/i.test(url)) {
        let pdf = encodeURIComponent(
          `${this.BASE_API}/Common.FileStore/GetFile/Performance?logicID=${url}`
        )
        window.open(
          '/static/pdf/web/viewer.html?file=' + pdf + '&v=1.0.0',
          'PDF'
        )
      }else if (/\.(?:ofd)+(:\d*)*$/i.test(url)){
        this.ofdFileUrl = `${this.BASE_API}/Common.FileStore/GetFile/Performance?logicID=${url}`
        // window.open(`https://ofd.xdocin.com/view?src=${this.ofdFileUrl}`)
        this.$common.previewWithKkFileView(this.ofdFileUrl)
      }  else {
        this.$message.error('该文件类型无法预览')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ReimbursementDetail {
  .projectInfo {
    background-color: #fff;
    padding: 0 16px 12px 16px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
    border-radius: 0px 8px 8px 8px;
    .pageHead {
      padding-bottom: 10px;
      border-bottom: 1px solid #f4f8fb;
      display: flex;
      justify-content: left;
      margin-bottom: 0;

      :deep(.el-page-header__content),
      :deep(.el-page-header__title) {
        font-weight: 500;
        font-size: 16px;
      }
    }
    .projectInfoItem {
      padding-top: 16px;
    }
  }
  .costInfo {
    margin-top: 12px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    padding: 16px 16px 12px 16px;
    .costInfoItem {
      padding-bottom: 12px;
    }
    .borderTop {
      border-top: 1px solid #f4f8fb;
      padding-top: 12px;
      padding-bottom: 0;
    }
  }
  .operateProcess {
    margin-top: 12px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    padding: 16px;
    .records {
      padding-top: 8px;
    }
  }
  .totalBox {
    margin-top: 12px;
    padding: 32px 100px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    .total {
      font-size: 18px;
      font-weight: 400;
      color: #494f69;
      i {
        font-style: normal;
        color: #ff4141;
      }
      span {
        font-size: 30px;
        font-weight: bold;
        color: #ff4141;
      }
    }
    .prompt {
      color: #999999;
      font-size: 14px;
    }
  }
  .moduleTitle {
    font-size: 16px;
    font-weight: bold;
    color: #494f69;
    margin-left: 12px;
    margin-bottom: 8px;
    position: relative;
    &::before {
      content: '';
      width: 4px;
      height: 18px;
      background: #154f9d;
      border-radius: 4px;
      position: absolute;
      left: -12px;
      top: 50%;
      transform: translateY(-50%);
    }
    .serialNum {
      display: inline-block;
      width: 16px;
      height: 16px;
      text-align: center;
      line-height: 16px;
      font-size: 12px;
      border-radius: 50%;
      border: 1px solid #ccc;
    }
  }
  .describeListItem {
    display: flex;
    box-sizing: border-box;
    .describeListItem {
      width: calc(100% / 4);
    }
    .describeListItemL {
      padding: 8px 0;
      font-weight: 400;
      color: #999;
      min-width: 126px;
      text-align: right;
    }
    .describeListItemR {
      padding: 8px 0;
      font-weight: 400;
      color: #3a4151;
    }
    .fileBox {
      display: flex;
      align-items: center;
      :deep(.el-link + .el-link) {
        margin-left: 16px;
      }
    }
    .status {
      padding: 4px 20px;
      border-radius: 6px;
      color: #3399ff;
      background: #f3f9ff;
    }
    .info {
      color: #909399;
      background: #f4f4f5;
    }
    .warning {
      color: #ffb829;
      background: #fff5e5;
    }
    .success {
      color: #41b035;
      background: #f4fbf3;
    }
    .danger {
      color: #ff4141;
      background: #fff3f3;
    }
  }
}
</style>
